export default __webpack_public_path__ + "static/media/Monger-HUD-04.0855e59c.jpg";